import React, { useMemo, useState } from 'react';
import { gql } from '@urql/core';
import {
    RecruitingHubEventsFragment,
    ParentRecruitingHubNotificationsFragment,
    ParentChildDropdownFragment,
    SpinNotificationDataFragment,
    ParentRecruitingHubFollowsFragment,
    ParentRecruitingHubMessagesFragment,
    ParentRecruitingHubProfileViewsFragment,
} from '../../../generated/spin-graphql';
import { PostSummary } from '../../../types/shared.types';
import { ParentChildDropdown } from '../ParentChildDropdown';
import { RecruitingHub } from './RecruitingHub';
import { Conversations } from '../../../pages/dashboard/messages';

type Props = {
    articles: PostSummary[];
    events: RecruitingHubEventsFragment[];
    playerInfo: ParentRecruitingHubNotificationsFragment[] | SpinNotificationDataFragment[];
    parentChildren: ParentChildDropdownFragment[];
    refetch: () => void;
    notifications: SpinNotificationDataFragment[];
    followers: ParentRecruitingHubFollowsFragment[];
    deletedFollowers: ParentRecruitingHubFollowsFragment[];
    following: ParentRecruitingHubFollowsFragment[];
    messages: ParentRecruitingHubMessagesFragment[];
    profileViews: ParentRecruitingHubProfileViewsFragment[];
    conversations: ParentConversations;
};

export type ParentConversations = {
    [user_id: string]: Conversations | undefined[];
};

gql`
    fragment ParentRecruitingHubNotifications on espin_notification {
        player_user_id
        player_user {
            player_profile {
                parent_profile {
                    ...ParentChildDropdown
                }
            }
        }
        ...NotificationsCard
    }
    fragment ParentRecruitingHubFollows on espin_follow {
        ...RecruitingHubFollows
    }
    fragment ParentRecruitingHubMessages on espin_message {
        ...RecruitingHubMessages
    }
    fragment ParentRecruitingHubProfileViews on espin_profile_view {
        ...RecruitingHubProfileViews
    }
`;

export const ParentRecruitingHub: React.FC<Props> = ({
    playerInfo,
    parentChildren,
    articles,
    events,
    refetch,
    followers,
    deletedFollowers,
    following,
    messages,
    profileViews,
    conversations,
    notifications,
}) => {
    const hasMultipleChildren = parentChildren[0]?.child_profiles.length > 1 ?? false;
    const [selectedPlayer, setSelectedPlayer] = useState(0);

    const filteredNotifsByPlayer = useMemo(() => {
        let notifs: SpinNotificationDataFragment[] = [];
        notifications.forEach((n, i) => {
            if (
                n?.player_user_id === parentChildren[0].child_profiles[selectedPlayer].user_id &&
                (n.follows.length > 0 || n.profile_views.length > 0 || n.messages.length > 0)
            ) {
                notifs.push(n);
            }
        });
        return notifs;
    }, [selectedPlayer, notifications, parentChildren]);

    return (
        <>
            {hasMultipleChildren && (
                <div className="parent-dropdown-container">
                    <ParentChildDropdown
                        playerInfo={parentChildren}
                        value={parentChildren[0].child_profiles[selectedPlayer]}
                        onChange={(value) => setSelectedPlayer(value)}
                    />
                </div>
            )}

            <RecruitingHub
                events={events}
                articles={articles}
                notifications={filteredNotifsByPlayer}
                refetch={refetch}
                followers={followers.filter(
                    (f) => f.player_user_id === parentChildren[0].child_profiles[selectedPlayer].user_id,
                )}
                deletedFollowers={deletedFollowers.filter(
                    (f) => f.player_user_id === parentChildren[0].child_profiles[selectedPlayer].user_id,
                )}
                following={following.filter(
                    (f) => f.player_user_id === parentChildren[0].child_profiles[selectedPlayer].user_id,
                )}
                messages={messages.filter(
                    (m) => m.player_user_id === parentChildren[0].child_profiles[selectedPlayer].user_id,
                )}
                profileViews={profileViews.filter(
                    (p) => p.player_user_id === parentChildren[0].child_profiles[selectedPlayer].user_id,
                )}
                conversations={
                    Object.keys(conversations[parentChildren[0]?.child_profiles[selectedPlayer]?.user_id] ?? [])
                        .length ?? 0
                }
            />
            {/* <RecruitingHub
                events={events}
                articles={articles}
                notifications={playerInfo
                    .filter((n) => n.player_user_id === parentChildren[0].child_profiles[selectedPlayer].user_id)
                    .slice(0, 6)}
                refetch={refetch}
                followers={followers.filter(
                    (f) => f.player_user_id === parentChildren[0].child_profiles[selectedPlayer].user_id,
                )}
                following={following.filter(
                    (f) => f.player_user_id === parentChildren[0].child_profiles[selectedPlayer].user_id,
                )}
                messages={messages.filter(
                    (m) => m.player_user_id === parentChildren[0].child_profiles[selectedPlayer].user_id,
                )}
                profileViews={profileViews.filter(
                    (p) => p.player_user_id === parentChildren[0].child_profiles[selectedPlayer].user_id,
                )}
                conversations={
                    Object.keys(conversations)[parentChildren[0].child_profiles[selectedPlayer].user_id] ?? []
                }
            /> */}
        </>
    );
};
